import { useState, useEffect } from 'react';
import Config from '../../config/config';

interface BookingInterface {
  id: number;
}

export const fetchBookingByReadToken = async (
  readToken: string | undefined,
  quickTravelUrl: string = Config.quickTravelUrl,
) => {
  if (!readToken) {
    throw new Error('Read token is required');
  }
  const response = await fetch(
    `${quickTravelUrl}/api/bookings/manage/${readToken}`,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
  const data = await response.json();
  if (response.ok) {
    return data;
  }
  throw new Error(data.error);
};

const useBooking = (readToken: string | undefined) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const [booking, setBooking] = useState<BookingInterface | null>(null);

  useEffect(() => {
    const fetchBooking = async () => {
      try {
        const data = await fetchBookingByReadToken(readToken);
        setBooking(data);
      } catch (err) {
        if (err instanceof Error) {
          setError(err);
        }
      } finally {
        setIsLoading(false);
      }
    };
    fetchBooking();
  }, [readToken]);

  return { isLoading, error, booking };
};

export default useBooking;
